import api from './api'


Plugin.install = function(Vue, options) {
  // 自定義插件 
  Object.defineProperties(Vue.prototype, {
    $axios: {
      get: () => api
    },
  });
};

export default Plugin;